export const getStyles = () => {
    const styles = {
        tabs: {
            pb: 1,
            "& .MuiTabs-indicator": {
                backgroundColor: "#D8CCBC",
            }
        },
        tab: {
            "&.Mui-selected": {
                color: "#D8CCBC",
            },
        }
    };
    return styles;
}